import { Link, useNavigate } from 'react-router-dom';

const siteJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://gracieandlily.com/#organization',
      name: 'Gracie & Lily Adventures',
  alternateName: [
    'Gracie and Lily Adventures',
    'Gracie & Lily',
    'Gracie and Lily',
  ],
  url: 'https://gracieandlily.com/',
  description:
    "Gracie & Lily Adventures is a children's storybook and family entertainment brand inspired by two real-life Bichon Frise sisters. The illustrated stories encourage friendship, kindness, courage, confidence, curiosity and imagination for children approximately ages 3 to 8.",
  logo: 'https://public.readdy.ai/ai/img_res/91ea3fda-8705-4921-ab9c-220fa8418490.png',
  image: 'https://public.readdy.ai/ai/img_res/91ea3fda-8705-4921-ab9c-220fa8418490.png',
  sameAs: [
    'https://www.facebook.com/gracieandlilyadventures/',
    'https://www.youtube.com/@GracieandLilyAdventures',
    'https://tinyurl.com/gumroadgracielily',
    'https://gracie-and-lilys-adventures.myshopify.com/',
    'https://www.etsy.com/shop/GracieandLilysAdv',
    'https://a.co/d/0gs915Vo',
  ],
  knowsAbout: [
    "Children's books",
    "Children's storybooks",
    "Illustrated children's books",
    'Bedtime stories',
    'Bichon Frise',
    'Dog adventure stories',
    'Friendship',
    'Kindness',
    'Courage',
    'Confidence',
    'Imagination',
    'Early reading',
    "Children's journals",
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer support',
      email: 'hello@gracieandlily.com',
      availableLanguage: ['English'],
    },
    },
    {
      '@type': 'WebSite',
      '@id': 'https://gracieandlily.com/#website',
      url: 'https://gracieandlily.com/',
      name: 'Gracie & Lily Adventures',
      description:
        "The official website of Gracie & Lily Adventures, a children's storybook brand featuring two Bichon Frise sisters, Gracie and Lily.",
      inLanguage: 'en',
      publisher: { '@id': 'https://gracieandlily.com/#organization' },
    },
  ],
};

export default function Footer() {
  const navigate = useNavigate();

  const goToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Section lives on the homepage, so route there with the hash.
      navigate(`/#${id}`);
    }
  };

  return (
    <>
      <footer className="w-full bg-primary-800 py-8 md:py-10 px-4 md:px-8">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-4">
          <img
            alt="Gracie & Lily Adventures"
            className="h-10 md:h-12 w-auto object-contain"
            src="https://public.readdy.ai/ai/img_res/91ea3fda-8705-4921-ab9c-220fa8418490.png"
          />
          <div>
            <p className="text-white font-extrabold text-base">Gracie & Lily Adventures</p>
            <p className="text-primary-200 text-xs">Magical stories for young hearts</p>
            <a
              href="https://www.etsy.com/shop/GracieandLilysAdv"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-1.5 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-white hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <span className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-shopping-basket-2-line text-sm"></i>
              </span>
              Shop on Etsy
            </a>
          </div>
        </div>

        <div className="flex flex-wrap gap-4 md:gap-8 justify-center">
          <Link
            to="/about"
            className="text-primary-200 hover:text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            About
          </Link>
          <button
            onClick={() => goToSection('books')}
            className="text-primary-200 hover:text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            Books
          </button>
          <button
            onClick={() => goToSection('sisters')}
            className="text-primary-200 hover:text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            Meet the Sisters
          </button>
          <button
            onClick={() => goToSection('stories')}
            className="text-primary-200 hover:text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            Stories
          </button>
          <Link
            to="/knowledge-base"
            className="text-primary-200 hover:text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            Knowledge Base
          </Link>
          <a
            href="https://a.co/d/0gs915Vo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-200 hover:text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors flex items-center gap-1"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-amazon-fill text-base"></i>
            </span>
            Shop on Amazon
          </a>
          <a
            href="https://www.etsy.com/shop/GracieandLilysAdv"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-200 hover:text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors flex items-center gap-1"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-basket-2-line text-base"></i>
            </span>
            Shop on Etsy
          </a>
          <a
            href="https://www.youtube.com/@GracieandLilyAdventures"
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary-200 hover:text-white text-sm font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            YouTube
          </a>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-2">
          <p className="text-primary-400 text-xs text-center md:text-right">
            © 2026 Gracie & Lily Adventures. All rights reserved.
          </p>
          <span className="inline-flex items-center gap-1 rounded-full bg-white/10 px-2.5 py-1 text-xs font-bold text-white">
            <i className="ri-information-line"></i>
            v4
          </span>
          </div>
        </div>
      </footer>
      <script
        type="application/ld+json"
        id="gracie-lily-site-jsonld"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteJsonLd) }}
      />
    </>
  );
}